import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { WebUserRecipientMappingMaintenanceComponent } from './web-user-recipient-mapping-maintenance.component';

const routes: Routes = [
  {
    path:'',
    component: WebUserRecipientMappingMaintenanceComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class WebUserRecipientMappingMaintenanceRoutingModule { }
